import { render, staticRenderFns } from "./cv1.vue?vue&type=template&id=018b71fe&scoped=true&"
import script from "./cv1.vue?vue&type=script&lang=js&"
export * from "./cv1.vue?vue&type=script&lang=js&"
import style0 from "./cv1.vue?vue&type=style&index=0&id=018b71fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b71fe",
  null
  
)

export default component.exports